const TIPOS_SEDES_JUDICIALES = [
  {
    id: 5,
    name: 'CAM - Madrid.org',
  },
  {
    id: 10,
    name: 'Generalidad Valenciana',
  },
  {
    id: 20,
    name: 'Xunta',
  },
  {
    id: 251,
    name: 'Sede Judicial de Aragon',
  },
  {
    id: 252,
    name: 'PSP Euskadi',
  },
  {
    id: 263,
    name: 'Sede Judicial de Navarra',
  },
  {
    id: 264,
    name: 'Sede Judicial de Cantabria',
  },
  // {
  //   id: 293,
  //   name: 'Tablón Edictal Único de Justicia',
  // },
  {
    id: 305,
    name: 'Sede Judicial Justicia',
  },
  {
    id: 326,
    name: 'Sede Judicial Galicia',
  },
]

export {
  TIPOS_SEDES_JUDICIALES
}
